import { c as _c } from "react/compiler-runtime";
import { SvgChevronright, SvgShoppingBasket } from '@common/__generated__/icon';
import { cn } from '@core/utils';
import type { UnifiedOrderDto } from '@generated/auth/types.gen';
import dayjs from 'dayjs';
import { useMemo } from 'react';
import { CustomLink } from '@/app/_components/CustomLink';
import LocalMarketLogoOnly from '@/assets/svgs/local-market-logo-only.svg';
import { DONATION_ROUTES, ROUTES } from '@/constants';
import { ProductCardList } from './ProductCardList';
interface OrderCardProps {
  order: UnifiedOrderDto;
}
const formatDate = (dateStr?: string) => {
  if (!dateStr) return '';
  return dayjs(dateStr).format('YYYY.MM.DD');
};
export const OrderCard = t0 => {
  const $ = _c(52);
  const {
    order
  } = t0;
  const isLocalMarket = order.orderType === "LOCAL_MARKET";
  const isPointMarket = order.orderType === "POINT_MARKET";
  let t1;
  if ($[0] !== order.vendorGroups) {
    t1 = order.vendorGroups ?? [];
    $[0] = order.vendorGroups;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = t1.flatMap(_temp);
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const flatProducts = t2;
  const expireAt = order.vendorGroups?.[0]?.products?.[0]?.options?.[0]?.expireAt;
  let t3;
  if ($[4] !== expireAt) {
    t3 = expireAt !== undefined && expireAt !== null ? dayjs(expireAt).diff(dayjs().startOf("day"), "day") : null;
    $[4] = expireAt;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const couponDaysLeft = t3;
  let t4;
  let t5;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = cn("flex flex-col", "mobile-tablet:px-20");
    t5 = cn("mb-16 flex items-center justify-between border-b border-Gray-200 py-10");
    t6 = cn("flex items-center gap-6", "mobile-tablet:gap-4");
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t4 = $[6];
    t5 = $[7];
    t6 = $[8];
  }
  let t7;
  if ($[9] !== isLocalMarket || $[10] !== isPointMarket) {
    t7 = !isPointMarket && (isLocalMarket ? <LocalMarketBadge /> : <DonationBadge />);
    $[9] = isLocalMarket;
    $[10] = isPointMarket;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== isPointMarket || $[13] !== order.totalDeliveryFee) {
    t8 = !isPointMarket && order.totalDeliveryFee === 0 && <FreeShippingBadge />;
    $[12] = isPointMarket;
    $[13] = order.totalDeliveryFee;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== couponDaysLeft || $[16] !== isPointMarket) {
    t9 = isPointMarket && couponDaysLeft !== null && couponDaysLeft >= 0 && <CouponExpiryBadge daysLeft={couponDaysLeft} />;
    $[15] = couponDaysLeft;
    $[16] = isPointMarket;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t7 || $[19] !== t8 || $[20] !== t9) {
    t10 = <div className={t6}>{t7}{t8}{t9}</div>;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  let t12;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = cn("flex items-center gap-6", "mobile-tablet:gap-4");
    t12 = cn("whitespace-nowrap font-600 text-Gray-600 typo-body4", "mobile-tablet:typo-caption1");
    $[22] = t11;
    $[23] = t12;
  } else {
    t11 = $[22];
    t12 = $[23];
  }
  let t13;
  if ($[24] !== order.orderedAt) {
    t13 = formatDate(order.orderedAt);
    $[24] = order.orderedAt;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t13) {
    t14 = <p className={t12}>{t13}</p>;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== isLocalMarket || $[29] !== isPointMarket || $[30] !== order.orderId || $[31] !== order.orderNo) {
    t15 = !isPointMarket && <CustomLink href={isLocalMarket ? ROUTES.MY_ORDERS_DETAIL.pathname({
      orderNo: order.orderNo ?? ""
    }) : DONATION_ROUTES.DONATION_MY_ORDERS_DETAIL.pathname({
      id: order.orderId ?? ""
    })} aria-label={"\uC8FC\uBB38 \uC0C1\uC138 \uD398\uC774\uC9C0\uB85C \uC774\uB3D9"} className={cn("flex items-center gap-4 whitespace-nowrap font-700 text-Gray-600 typo-body4", "mobile-tablet:typo-caption1")}>주문상세<SvgChevronright className={cn("size-16 text-Gray-600", "mobile-tablet:size-12")} /></CustomLink>;
    $[28] = isLocalMarket;
    $[29] = isPointMarket;
    $[30] = order.orderId;
    $[31] = order.orderNo;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t14 || $[34] !== t15) {
    t16 = <div className={t11}>{t14}{t15}</div>;
    $[33] = t14;
    $[34] = t15;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t10 || $[37] !== t16) {
    t17 = <div className={t5}>{t10}{t16}</div>;
    $[36] = t10;
    $[37] = t16;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  const t18 = order.orderId ?? "";
  const t19 = order.orderNo ?? "";
  let t20;
  if ($[39] !== flatProducts || $[40] !== order.orderStatus || $[41] !== order.orderStatusName || $[42] !== order.orderType || $[43] !== t18 || $[44] !== t19) {
    t20 = <ProductCardList products={flatProducts} orderId={t18} orderNo={t19} orderType={order.orderType} orderStatus={order.orderStatus} orderStatusName={order.orderStatusName} />;
    $[39] = flatProducts;
    $[40] = order.orderStatus;
    $[41] = order.orderStatusName;
    $[42] = order.orderType;
    $[43] = t18;
    $[44] = t19;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  let t21;
  if ($[46] !== t17 || $[47] !== t20) {
    t21 = <li className={t4}>{t17}{t20}</li>;
    $[46] = t17;
    $[47] = t20;
    $[48] = t21;
  } else {
    t21 = $[48];
  }
  let t22;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <li className={cn("h-80 w-full last-of-type:hidden", "mobile-tablet:my-40 mobile-tablet:h-10 mobile-tablet:bg-Gray-100")} />;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  let t23;
  if ($[50] !== t21) {
    t23 = <>{t21}{t22}</>;
    $[50] = t21;
    $[51] = t23;
  } else {
    t23 = $[51];
  }
  return t23;
};
const LocalMarketBadge = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={cn("gap-2 whitespace-nowrap rounded-xsmall bg-Gray-200 px-8 py-4 flex-center", "mobile-tablet:px-6 mobile-tablet:py-2")}><LocalMarketLogoOnly className="size-12" /><span className={cn("font-600 text-Gray-900 typo-body4", "mobile-tablet:typo-caption2")}>웰마켙</span></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const FreeShippingBadge = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={cn("whitespace-nowrap rounded-xsmall bg-G-400 px-8 py-4 flex-center", "mobile-tablet:px-6 mobile-tablet:py-2")}><span className={cn("font-600 text-Gray-white typo-body4", "mobile-tablet:typo-caption2")}>무료배송</span></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const CouponExpiryBadge = t0 => {
  const $ = _c(4);
  const {
    daysLeft
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("whitespace-nowrap rounded-small bg-Gray-400 px-8 py-4 flex-center", "mobile-tablet:px-6 mobile-tablet:py-2");
    t2 = cn("font-600 text-Gray-white typo-body4", "mobile-tablet:typo-caption2");
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== daysLeft) {
    t3 = <div className={t1}><span className={t2}>D-{daysLeft}</span></div>;
    $[2] = daysLeft;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
const DonationBadge = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = cn("gap-2 whitespace-nowrap rounded-xsmall bg-O-300 px-8 py-4 flex-center", "mobile-tablet:px-6 mobile-tablet:py-2");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className={t0}><SvgShoppingBasket className={cn("size-16 text-O-25", "mobile-tablet:size-12")} /><span className={cn("font-600 text-O-25 typo-body4", "mobile-tablet:typo-caption2")}>고향사랑기부</span></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
function _temp(vendor) {
  return (vendor.products ?? []).map(product => ({
    ...product,
    vendorName: vendor.vendorName,
    govCodeName: vendor.govCodeName,
    deliveryId: vendor.deliveryId,
    trackingProvider: vendor.trackingProvider
  }));
}